import store from "@/store";
import { CheckAuthorizeStatusAsync,
     CheckAuthorizeStatusAsyncAndCloseModal   
 } from "../authService";

//For Applicants
export async function getPackagesAsync(){
    const url = `${process.env.VUE_APP_API_URL}Billing/Packages`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': token != null? `Bearer ${token}` : ``
        }
    });
   
    return response.json();

}


export async function payForJobSeeker(){

    const url = `${process.env.VUE_APP_API_URL}Billing/PayJobSeeker`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
        'Accept': 'application/json',
        'Authorization': token != null? `Bearer ${token}` : ``
        } 
    });
    await CheckAuthorizeStatusAsync(response);
    return response.json();
    
}

export async function payForEmployer(){

    const url = `${process.env.VUE_APP_API_URL}Billing/PayEmployer`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
        'Accept': 'application/json',
        'Authorization': token != null? `Bearer ${token}` : ``
        } 
    });
    await CheckAuthorizeStatusAsync(response);
    return response.json();
    
}

export async function VerifyPayment(){

    const url = `${process.env.VUE_APP_API_URL}Billing/VerifyPayment`;
    // Get token from Vuex store
    let token = store.state.auth.token;
    const response = await fetch(url, {
        method: 'GET',
        headers: {
        'Accept': 'application/json',
        'Authorization': token != null? `Bearer ${token}` : ``
        } 
    });
    await CheckAuthorizeStatusAsync(response);
    return response.json();
    
}

